import { useQuery } from '@apollo/client';
import useProductActions from 'FeatureModules/ProductPage/hooks/useProductActions';
import { GET_PRODUCT_AND_BASE_CHAIN } from 'graphql/secure/queries/product.queries';
import { useParams } from 'react-router-dom';
import { IProduct } from 'FeatureModules/ProductPage/types/product.types';

const useSupplyChain = () => {
  const { productId } = useParams<{ productId: string }>();
  const { handleEditProduct: editProduct } = useProductActions();

  const { data, loading, error } = useQuery<{
    product: IProduct;
  }>(GET_PRODUCT_AND_BASE_CHAIN, { variables: { id: productId } });

  const product = data?.product;

  const handleEditProduct = async () => {
    if (!product) {
      // eslint-disable-next-line no-console
      console.error('No product found');
      return;
    }
    editProduct(product);
  };

  return {
    product,
    loading,
    error,
    handleEditProduct,
  };
};

export default useSupplyChain;
